
export default {
    state: {
        theme: 'light',
    },
    getters: {
        getTheme(state: any) {
            return state.theme;
        }
    },
    actions: {
        setTheme({ commit }: any, value: string) {
            commit('setTheme', value);
        }

    },
    mutations: {
        setTheme(state: any, value: string) {
            state.theme = value;
            document.documentElement.setAttribute('data-theme', value);
        }
    }
}